module.exports = __webpack_public_path__ + "static/media/do-not-disturb.fae31c3b.svg";